// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Zm-k","colMin":"styles_colMin__2llAs"};